import '@/init'
import {render} from 'preact'
import {App} from '@c/app'
import {store} from '@/core/utils/store'
import {router} from '@/core/utils/routing/router'
import './style/index.less'

window.addEventListener('vite:preloadError', window.__reloadOnce)

store.init()

window.v2Route = opts => router(store).push(opts)

render(<App />, document.getElementById('v2'))
